import { render, staticRenderFns } from "./SingleUpLoad.vue?vue&type=template&id=ef77a7a8&scoped=true&"
import script from "./SingleUpLoad.vue?vue&type=script&lang=js&"
export * from "./SingleUpLoad.vue?vue&type=script&lang=js&"
import style0 from "./SingleUpLoad.vue?vue&type=style&index=0&id=ef77a7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef77a7a8",
  null
  
)

export default component.exports